import React, { useEffect, useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import Img_1 from '../../images/school-g.png';
import Img_2 from '../../images/collage-g.png';
import Img_3 from '../../images/school-p.png';
import Img_4 from '../../images/collage-p.png';
import * as colors from "../../assets/css/Colors";

const Index = () => {
    const [colorScheme, setColorScheme] = useState(
        window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            setColorScheme(e.matches ? 'dark' : 'light');
        };
        mediaQuery.addEventListener('change', handleChange);
        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);

    const individualDuration = 2; 
const repeatDelay = individualDuration * 2.5; 
const animationDelays = [0, individualDuration * 1, individualDuration * 2, individualDuration * 3, individualDuration * 4]; 

const buttonStyle = (index) => ({
    backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color,
    boxShadow: `0 0 0 3px ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
    animationIterationCount: `infinite`,
    animationDelay: `${animationDelays[index]}s`,
});

    return (
        <>
            <div className="ban-ql">
                <Container>
                    <Row>
                        <ul>
                            <li>
                                <div>
                                    <img src={Img_1} alt=""/>
                                    <h4>Government Schools</h4>
                                    <p>Select Government Schools And Get All The Information</p>
                                    <Link style={buttonStyle(1)} to="/Government-Schools" className='btn-ser-need-ani schoolcollegebutton'>Explore Now</Link>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <img src={Img_2} alt=""/>
                                    <h4>Government Colleges</h4>
                                    <p>Select Government Colleges And Get All The Information</p>
                                    <Link style={buttonStyle(2)} to="/Government-Schools" className='btn-ser-need-ani schoolcollegebutton'>Explore Now</Link>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <img src={Img_3} alt=""/>
                                    <h4>Private Schools</h4>
                                    <p>Select Private Schools And Get All The Information</p>
                                    <Link style={buttonStyle(3)} to="/Government-Schools" className='btn-ser-need-ani schoolcollegebutton'>Explore Now</Link>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <img src={Img_4} alt=""/>
                                    <h4>Private Colleges</h4>
                                    <p>Select Private Colleges And Get All The Information</p>
                                    <Link style={buttonStyle(4)} to="/Government-Schools" className='btn-ser-need-ani schoolcollegebutton'>Explore Now</Link>
                                </div>
                            </li>
                        </ul>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default Index;
